import { store } from 'src/common/redux/configure-store';
import { CustomerServiceUserActions } from '../interfaces/customer-service-user-actions';

const customerServiceAccess = (): CustomerServiceUserActions => {
  const customerServiceActions: CustomerServiceUserActions = {
    allActions: false,
    returnAll: false,
    returnTransaction: true,
    transactionBasedReturn: false,
    bottleReturn: true,
  };

  const transactionState = store.getState().transaction;
  const isNoSaleMode = !transactionState.transactionIdExists;

  if (isNoSaleMode) {
    customerServiceActions.returnTransaction = false;
    customerServiceActions.bottleReturn = false;
  }
  const returnModeActive = !!store.getState().posMode.returnMode.returnType;

  if (returnModeActive) {
    customerServiceActions.bottleReturn = true;
  }
  return customerServiceActions;
};

export const HandleCustomerServiceActions = {
  customerServiceAccess,
};
